<template lang="html">
  <section class="vh intro">
    <div>
      <a href="#" v-scroll-to="'.cat-1'" class="scrolldown"></a>
      <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft -introText">
        <div class="container-text">
          <div v-html="$t('productos.intro.titulo')"></div>
          <p v-html="$t('productos.intro.texto')"></p>
        </div>
      </div>
    </div>
    <div id="slider">
      <ul>
        <li v-for="(slide, index) in slides" :key="index" :class="{ on: index === currentIndex }">
          <img :src="slide.img" :alt="slide.alt" :title="slide.alt">
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="js">
let timer = null;
const AUTO_INTERVAL = 6000;
import { mapGetters } from 'vuex'

export default {
  name: 'productos',
  props: [],
  created() {
    this.play();
  },
  data() {
    return {
      slides: [
        {
          name: 'juntas_culata',
          img: '/static/img/products/slider-producto-1.webp',
          alt: this.$t('productos.alt_images.juntas_culata')
        },
        {
          name: 'tornillos',
          img: '/static/img/products/slider-producto-2.webp', 
          alt: this.$t('productos.alt_images.tornillos')
        },
        {
          name: 'tubos_engrase',
          img: '/static/img/products/slider-producto-3.webp',
          alt: this.$t('productos.alt_images.tubos_engrase')
        }
      ],
      currentIndex: 0
    }
  },
  methods: {
    setAutoRoll() {
      let vueSelf = this;
      timer = setInterval(function () {
        vueSelf.addIndex();
      }, AUTO_INTERVAL);
    },
    addIndex() {
      let newIndex = this.currentIndex + 1;
      this.currentIndex = newIndex === this.slides.length ? 0 : newIndex;
    },
    play() {
      this.setAutoRoll();
    },
  },
  computed: {
    ...mapGetters({
      lang : 'getLanguage'
    })
  },
  watch : {
    'lang'(){
      this.slides.forEach(slide => {
        slide.alt = this.$t(`productos.alt_images.${slide.name}`)
      })
    }
  }
}
</script>

<style scoped>
  body {
    background-color: #2C3E50;
  }
  #slider {
    margin: 0;
    padding: 0;
  }
  #slider ul {
    list-style-type: none;
    margin: -7px;
    padding: 0;
  }
  #slider li {
    display: none;
  }
  #slider li img {
    width: 100%;
    height: 100%;
  }
  #slider li.on {
    display: block;
  }
  @media screen and (max-width: 850px){
    #slider li img {
      width: 100%;
      min-height: 65vh;
      object-fit: cover;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/productos.vue